<div
  [ngClass]="{
    'cursor-pointer': clickable(),
    'cursor-default': !clickable(),
    group: showHoverEffect(),
    'transition-all duration-300': showHoverEffect(),
  }"
  class="w-full flex flex-col"
  (click)="onCardClick()">
  <div
    class="relative w-full overflow-hidden"
    [ngClass]="aspectRatioClass()">
    <div
      [lazyBgLoader]="data().imageUrl"
      (imageLoaded)="onImageLoaded()"
      class="w-full h-full p-3 flex justify-end items-end transition-transform duration-300"
      [ngClass]="{
        'group-hover:scale-105': showHoverEffect() && clickable(),
        'cursor-custom': clickable(),
      }"></div>

    @if (data().chipText && showChipOnImage()) {
      <div class="absolute top-4 left-4">
        <span class="bg-neon/20 text-neon px-4 py-2 rounded-full text-sm font-semibold border border-neon/30">
          {{ data().chipText || '' | translate }}
        </span>
      </div>
    }
  </div>

  <div class="mt-2">
    @if (data().dateText || data().tags) {
      <p class="text-xs leading-4 text-neon uppercase">
        @if (data().dateText) {
          <span>{{ isDate(data().dateText) ? (data().dateText | localizedDate: 'dd MMM') : data().dateText }}__</span>
        }
        @if (data().tags) {
          @for (tag of data().tags; track tag; let last = $last) {
            <span>
              {{ tag }}
              @if (!last) {
                |
              }
            </span>
          }
        }
      </p>
    }

    @if (data().chipText && !showChipOnImage()) {
      <p class="text-xs leading-4 text-neon uppercase">{{ data().chipText || '' | translate }}</p>
    }

    <p
      class="uppercase"
      [class]="data().titleColor ?? 'text-white'">
      {{ data().title | translate }}
    </p>

    @if (data().description) {
      <p class="text-white text-sm leading-relaxed">{{ data().description || '' | translate }}</p>
    }
  </div>
</div>
